var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{staticStyle:{"height":"20px","margin":"10px 0"},attrs:{"separator":"/"}},_vm._l((_vm.currentPath),function(item){return _c('el-breadcrumb-item',{key:item.path},[_vm._v(" "+_vm._s(item.meta.title)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }